import { styled } from '@mui/material/styles';
import { getIdvThemeTokens } from '../themeTokens';

export const ExcludeRoot = styled('label', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => {
  const t = getIdvThemeTokens(theme);
  return {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 9,
    minWidth: 240,
    maxWidth: 280,
    padding: '10px 12px',
    border: `1px solid ${t.border}`,
    borderRadius: 8,
    background: t.surface,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
    color: t.text,
    '& input': {
      width: 16,
      height: 16,
      margin: '2px 0 0',
      flexShrink: 0,
      accentColor: t.violet,
      cursor: disabled ? 'not-allowed' : 'pointer',
    },
  };
});

export const ExcludeCopy = styled('span')({
  minWidth: 0,
});

export const ExcludeLabel = styled('strong')({
  display: 'block',
  fontSize: 12,
  fontWeight: 700,
});

export const ExcludeHelper = styled('small')(({ theme }) => ({
  display: 'block',
  marginTop: 2,
  color: getIdvThemeTokens(theme).textMuted,
  fontSize: 11,
  lineHeight: 1.4,
}));
